import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'

import 'maplibre-gl/dist/maplibre-gl.css'

// Vuetify
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import {
    VApp,
    VAppBar,
    VAppBarNavIcon,
    VBtn,
    VCard,
    VCardActions,
    VCardText,
    VCardTitle,
    VChip,
    VCol,
    VContainer,
    VDivider,
    VExpandTransition,
    VIcon,
    VList,
    VListItem,
    VListItemTitle,
    VMain,
    VNavigationDrawer,
    VProgressCircular,
    VTab,
    VTabs,
    VToolbarTitle,
    VRow
} from 'vuetify/components'

const app = createApp(App)

const head = createHead()
app.use(head)

const vuetify = createVuetify({
    components: {
        VApp,
        VAppBar,
        VAppBarNavIcon,
        VBtn,
        VCard,
        VCardActions,
        VCardText,
        VCardTitle,
        VChip,
        VCol,
        VContainer,
        VDivider,
        VExpandTransition,
        VIcon,
        VTab,
        VTabs,
        VToolbarTitle,
        VList,
        VListItem,
        VListItemTitle,
        VMain,
        VNavigationDrawer,
        VProgressCircular,
        VRow
    },
    icons: {
        defaultSet: 'mdi'
    }
})

// Track route changes for SPA
router.afterEach((to) => {
  if (window.gtag) {
    window.gtag('config', 'G-22DJ2JWMGG', {
      page_path: to.fullPath,
      page_title: to.name || to.path
    })
  }
})

// Make gtag available globally for custom events
app.config.globalProperties.$gtag = window.gtag

app.use(router)
app.use(vuetify)

app.mount('#app')
